import React from 'react';

import Box from '@mui/material/Box';
import SkeletonMui from '@mui/material/Skeleton';

const Skeleton: React.FC = () => {
  return (
    <Box width="100%">
      {Array.from({ length: 3 }).map((_, index) => (
        <SkeletonMui key={index} />
      ))}
    </Box>
  );
};

export default Skeleton;
